import React from 'react';
import { instanceOf, bool, func } from 'prop-types';
import { DropTarget as dropTarget } from 'react-dnd';

import SelectionList from './SelectionList';

const target = {
  drop({ selectedTargets }) {
    return {
      selectedTargets,
    };
  },
};

const collect = (connect, monitor) => ({
  connectDropTarget: connect.dropTarget(),
  highlighted: monitor.canDrop(),
});

const TcSelections = ({ selectedTargets, loading, highlighted, connectDropTarget }) => {
  const defaultMessage = (
    <div className="ie--target--selections--default">
      *Adults 18+
    </div>
  );
  const boxClass = `ie--target--selections--box ${
    highlighted ? 'ie--target--selections--box--heighlited' : '  '
  }`;
  return connectDropTarget(
    <div className={boxClass}>
      {loading && (
        <div className="ie--target--selections--box--disabled">&nbsp;</div>
      )}
      <div className="ie--target--selections--container">
        {selectedTargets.length > 0 ? <SelectionList loading={loading} /> : defaultMessage}
      </div>
    </div>
  );
};

TcSelections.propTypes = {
  selectedTargets: instanceOf(Array),
  highlighted: bool,
  connectDropTarget: func,
  loading: bool,
};

TcSelections.defaultProp = {
  selectedTargets: [],
  highlighted: false,
  loading: true,
};

export default dropTarget('TC_OPTIONS', target, collect)(TcSelections);
